<template>

        <multiselect
            v-model="data"
            track-by="id"
            label="name"
            :options="options"
            :placeholder="placeholder"
            :allowEmpty="allowEmpty"
            :custom-label="customStatusLabel"
            :show-labels="false"
            :searchable="false"
            :class="['singleSelect', type ? type : '','statusSelector']"
            @select="onSelect"
            @remove="onReset" :style="{ 'min-width': minWidth +'px'}">

            <template slot="option" slot-scope="props">
                <span :class="'option__statusIndicator ' + props.option.name"></span>
                <span :class="'option__title '+props.option.name">{{ $t(label + props.option.name) }}</span>
            </template>

            <template slot="loading">
                <span :class="'option__statusIndicator ' + (data != null ? data.name : '')"></span>
            </template>

        </multiselect>

</template>


<script>
import Multiselect from 'vue-multiselect';

export default {

	name: 'multiselector',

	components: {
		Multiselect
	},

  props: {
    type: {
        type: String,
        default: 'pageStatus'
    },
    data: {
        type: Object,
        default: null
    },
    options2: {
        type: Array,
        default: null,
    },
    label: {
        type: String,
        default: ''
    },
    placeholder: {
        type: String,
        default: 'Status wählen'
    },
    allowEmpty: {
        type: Boolean,
        default: false
    },
    minWidth: {
        type: String,
        default: '150'
    }
  },

	data() {
		return {

		}
	},

  computed: {

    pageStatus() {

    	var status = this.$store.getters.getTermsByTaxonomyRaw('CATALOG_PAGE_STATUS');

      // userrole "Redaktion" must only see status "ready" and status "edited"
      if(this.userRole != 'Redaktion') {
          return status;
      }

  			var list =[];
  			status.forEach(function(status) {
  				if(status.name == 'READY' || status.name == 'EDITED') {
  					list.push(status);
  				}
  			})

  			return list;

		},

    pageElementStatus() {

      // return this.$store.getters.getTermsByTaxonomyRaw('CATALOG_PAGE_ELEMENT_STATUS');

      let status = this.$store.getters.getTermsByTaxonomyRaw('CATALOG_PAGE_ELEMENT_STATUS');

      // userrole "Redaktion" must only see status "ready" and status "edited"
      if(this.userRole != 'Redaktion') {
          return status;
      }

    	var list = [];
    	status.forEach(function(status) {
    		if(status.name == 'CREATED' || status.name == 'EDITED') {
    			list.push(status);
    		}
			})

			return list;
    },

    siteCatalogStatus() {
        return this.$store.getters.getTermsByTaxonomyRaw('SITE_CATALOG_STATUS');
    },

    equipmentCatalogPageStatus() {
        return this.$store.getters.getTermsByTaxonomyRaw('EQUIPMENT_CATALOG_PAGE_STATUS')
    },

  },

  created() {

      if(this.type == 'pageStatus') {
          this.options = this.pageStatus;
      }
      else if(this.type == 'pageElementStatus') {
          this.options = this.pageElementStatus;
      }
      else if(this.type == 'siteCatalogStatus') {
          this.options = this.siteCatalogStatus;
      }
      else if(this.type == 'catalogSections') {
          this.options = this.options2;
      }
      else if(this.type == 'equipmentCatalogPageStatus') {
          this.options = this.equipmentCatalogPageStatus;
      }

  },

  methods: {

    onSelect(selectedOption, id) {

      // update the model in the parent component
      this.$emit('update:data', selectedOption);

      // trigger @change in parent component
      this.$emit('change', selectedOption);

    },

    onReset(removedOption, id) {

      // update the model in the parent component
      this.$emit('update:data', null);

      // trigger @change in parent component
      this.$emit('change');

    },

    customStatusLabel (val) {

      if(this.label == "") {
        return this.$t('SELECT_BOX-STATUS_' + val.name);
      } else {
          return this.$t(this.label + val.name);
      }

    },

  }

}
</script>


<style lang="scss">

    @import '../../assets/css/variables.scss';

	.option__statusIndicator.CREATED {
		background: $statusCreated !important;
	}
	.option__statusIndicator.READY {
		background: $statusReady !important;
	}
	.option__statusIndicator.EDITED {
		background: $statusEdited !important;
	}
	.option__statusIndicator.LAYOUTED {
		background: $statusLayouted !important;
	}
	.option__statusIndicator.REVISED {
		background: $statusRevised !important;
	}
	.option__statusIndicator.APPROVED {
		background: $statusApproved !important;
	}
	.option__statusIndicator.PRINT_APPROVED {
		background: $statusPrintApproved !important;
	}
	.option__statusIndicator.REVIEW {
		background: $statusReview !important;
	}


    .siteCatalogStatus .option__statusIndicator.NONE {
		background: $statusCreated !important;
	}
    .siteCatalogStatus .option__statusIndicator.APPROVAL_REQUESTED {
        background: $statusApprovalRequested !important;
    }
    .siteCatalogStatus .option__statusIndicator.APPROVED {
        background: $statusSiteApproved !important;
    }
    .siteCatalogStatus .option__statusIndicator.COORDINATION {
        background: $statusReview !important;
    }
    .siteCatalogStatus .option__statusIndicator.READY {
        background: $statusEdited !important;
    }
    .siteCatalogStatus .option__statusIndicator.LAYOUTED {
		background: $statusLayouted !important;
    }
    .siteCatalogStatus .option__statusIndicator.PRINT_APPROVAL_REQUESTED {
        background: $statusPrintApprovalRequested !important;
    }
    .siteCatalogStatus .option__statusIndicator.PRINT_APPROVED {
        background: $statusRevised !important;
    }
    .siteCatalogStatus .option__statusIndicator.PRINT_READY {
        background: $statusPrintApproved !important;
    }

    .ecp .option__statusIndicator.DEFAULT {
        background: $statusEquipmentCatalogPageDefault !important;
    }
    .ecp .option__statusIndicator.EDIT {
        background: $statusEquipmentCatalogPageEdit !important;
    }
    .ecp .option__statusIndicator.READY {
        background: $statusEquipmentCatalogPageReady !important;
    }

</style>
